import { useEffect, useRef } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { FaMapLocationDot } from "react-icons/fa6";
import { Link } from "react-router-dom";
import logo from "../../../assets/logo/logo_4.png";

export default function Footer() {
  const orbRef = useRef<HTMLDivElement | null>(null);

  // Cursor-follow effect for orb
  useEffect(() => {
    const handleMove = (e: MouseEvent) => {
      if (orbRef.current) {
        orbRef.current.style.left = `${e.clientX}px`;
        orbRef.current.style.top = `${e.clientY}px`;
      }
    };
    window.addEventListener("mousemove", handleMove);
    return () => window.removeEventListener("mousemove", handleMove);
  }, []);

  return (
    <>
      <footer className="bg-gradient-to-br from-gray-900 to-gray-900 text-white  pt-12 pb-8 font-workSans">
        <div className="container mx-auto px-4">
          <div className="flex items-center lg:flex-row flex-col">
            <div className="flex flex-col items-center gap-[14px] lg:w-[40%] w-full mb-8">
              <div className="flex flex-col items-center justify-center brightness-0 invert">
                <img
                  src={logo}
                  alt="ProRes"
                  className="w-[300px] h-auto lg:w-[440px] object-cover pb-[10px]"
                />
                <div>
                  <div
                    className={`
              text-2xl font-bold tracking-tight transition-all duration-500
              ${false ? "text-gray-900" : "text-white"}
            `}
                  ></div>
                  <p className="text-gray-300 mb-1">
                    Engineering precision glove-box systems for advanced
                    research & industry.
                  </p>
                </div>
              </div>
              <div className="flex space-x-4">
                <a
                  href="https://www.linkedin.com/in/jagadish-sheregar-1a211712b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                  title="LinkedIn"
                  target="_blank"
                  rel="noreferrer"
                  className="group text-white transition-all duration-300
             hover:text-blue-400 hover:scale-110"
                >
                  <span className="sr-only">LinkedIn</span>

                  <svg
                    className="h-6 w-6 transition-transform duration-300"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fillRule="evenodd"
                      d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>

                <a
                  href="https://www.facebook.com/profile.php?id=61573681677505"
                  title="Facebook"
                  target="_blank"
                  rel="noreferrer"
                  className="group text-white transition-all duration-300
             hover:text-blue-400 hover:scale-110"
                >
                  <span className="sr-only">Facebook</span>

                  <svg
                    className="h-6 w-6 transition-transform duration-300"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fillRule="evenodd"
                      d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>

                <a
                  href="https://www.instagram.com/prores_scientific/?igsh=dzB2MW5jYWhwdGN4&utm_source=qr#"
                  title="Instagram"
                  target="_blank"
                  rel="noreferrer"
                  className="group inline-flex"
                >
                  <span className="sr-only">Instagram</span>
                  <svg
                    className="
                    h-6 w-6
                    text-matteblue-50
                    transition-all duration-300 ease-in-out
                    group-hover:text-blue-400
                    group-hover:scale-110
                  "
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </a>

           <a
  href="https://www.youtube.com/@proresscientificllp9881"
  title="YouTube"
  target="_blank"
  rel="noreferrer"
  className="group inline-flex"
>
  <span className="sr-only">YouTube</span>

  <svg
    className="
      h-6 w-6
      text-matteblue-50
      transition-all duration-300 ease-in-out
      group-hover:text-blue-400
      group-hover:scale-110
    "
    fill="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.498 6.186a3.02 3.02 0 00-2.13-2.136C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.368.55A3.02 3.02 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.02 3.02 0 002.13 2.136C4.495 20.5 12 20.5 12 20.5s7.505 0 9.368-.55a3.02 3.02 0 002.13-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
    />
  </svg>
</a>

              </div>
              <div className="text-center">
                <div className=" text-gray-300 ">
                  <a
                    href="https://maps.app.goo.gl/qVSxQvkVpcSUzT3R8"
                    target="_blank"
                    rel="noreferrer"
                    className="para-1-lower mb-[10px]"
                  >
                    No. 362/5, Site No.5, Santhosh Layout, Kadabgere Cross,
                    Bengaluru
                  </a>
                  <p className="para-1-lower mb-0 mt-[8px]">
                    {/* Phone:  */}
                    <a
                      href="tel:+919844606132"
                      className="text-white hover:text-blue-400 transition"
                    >
                      +91 98446 06132
                    </a>{" "}
                    / <br className="xs:block sm:hidden md:hidden lg:hidden" />
                    <a
                      href="tel:+919620832434"
                      className="text-white hover:text-blue-400 transition"
                    >
                      +91 96208 32434
                    </a>
                  </p>
                  <p className="para-1-lower mt-[8px]">
                    {/* Email:{" "} */}
                    <a
                      href="mailtp:js@proresscientific.in"
                      className="text-white hover:text-blue-400 transition"
                    >
                      js@proresscientific.in
                    </a>{" "}
                    / <br className="xs:block sm:hidden md:hidden lg:hidden" />
                    <a
                      href="mailto:bharath@proresscientific.in"
                      className="text-white hover:text-blue-400 transition"
                    >
                      bharath@proresscientific.in
                    </a>
                  </p>
                </div>
                <div className="flex justify-center mt-[8px]">
                  <a
                    href="https://maps.app.goo.gl/dZRQVoJ9tmo4bWeq5"
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center bg-blue-500/20 text-white hover:bg-blue-400 rounded-full py-[5px] px-[16px] mr-[10px] cursor-pointer"
                  >
                    <FaMapLocationDot />
                    &nbsp; Get Directions
                  </a>
                  <a
                    href="tel:+919844606132"
                    className="flex items-center bg-blue-500/20 text-white hover:bg-blue-400 rounded-full py-[5px] px-[16px] mr-[10px] cursor-pointer"
                  >
                    <FaPhoneAlt />
                    &nbsp; Call Us
                  </a>
                </div>
              </div>
            </div>
            <div className="hidden lg:w-[60%] w-full md:grid md:grid-cols-3 lg:grid-cols-3 gap-8 mb-8 text-center">
              <div className="space-y-2">
                <h3 className="text-lg font-semibold text-blue-300">
                  Quick Links
                </h3>
                <ul className="space-y-2">
                  <li>
                    <Link
                      to="/products"
                      className="text-white hover:text-blue-400 hover:font-bold"
                    >
                      Products
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/services"
                      className="text-white hover:text-blue-400 hover:font-bold"
                    >
                      Services
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/applications"
                      className="text-white hover:text-blue-400 hover:font-bold"
                    >
                      Applications
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/dashboard"
                      className="text-white hover:text-blue-400 hover:font-bold"
                    >
                      Admin
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="space-y-2">
                <h3 className="text-lg font-semibold text-blue-300">
                  Products
                </h3>
                <ul className="space-y-2">
                  <li>
                    <Link
                      to={`/detail-page?key=${"prolab-gb-2"}`}
                      className="text-white hover:text-blue-400 hover:font-bold"
                    >
                      Pro-Lab GB II
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/detail-page?key=${"prolab-gb-3"}`}
                      className="text-white hover:text-blue-400 hover:font-bold"
                    >
                      Pro-Lab GB III
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/detail-page?key=${"prolab-gb-4"}`}
                      className="text-white hover:text-blue-400 hover:font-bold"
                    >
                      Pro-Lab GB IV
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/detail-page?key=${"prolab-gb-custom"}`}
                      className="text-white hover:text-blue-400 hover:font-bold"
                    >
                      Pro-Lab GB Custom
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="space-y-2">
                <h3 className="text-lg font-semibold  text-blue-300">
                  Reach Us
                </h3>
                <ul className="space-y-2">
                  <li>
                    <Link
                      to={`/contact-us`}
                      className="text-white hover:text-blue-400 hover:font-bold"
                    >
                      Contact Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/quote`}
                      className="text-white hover:text-blue-400 hover:font-bold"
                    >
                      Get a Quote
                    </Link>
                  </li>
                  <li>
                    <a
                      href="https://www.facebook.com/profile.php?id=61573681677505"
                      className="text-white hover:text-blue-400 hover:font-bold"
                    >
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/prores_scientific/?igsh=dzB2MW5jYWhwdGN4&utm_source=qr#"
                      className="text-white hover:text-blue-400 hover:font-bold"
                    >
                      Instagram
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="border-t border-matteblue-50 pt-6 flex flex-col md:flex-row  items-center justify-around">
            <p className="text-white text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} ProRes. All rights reserved.
            </p>
            <p className="text-white text-sm mb-4 md:mb-0">
              Powered by &nbsp;
               <span className="font-bold hover:font-extrabold hover:text-blue-400">
                <a href="https://www.parichayatechsolutions.com" 
                rel="noopener noreferrer"
                target="_blank">Parichaya Tech Solutions.</a>
                </span> 
            </p>
            {/* <div className="flex space-x-6">
                <a
                  href="/"
                  className="text-matteblue-50 hover:text-white text-sm transition"
                >
                  Privacy Policy
                </a>
                <a
                  href="/"
                  className="text-matteblue-50 hover:text-white text-sm transition"
                >
                  Terms of Service
                </a>
                <a
                  href="/"
                  className="text-matteblue-50 hover:text-white text-sm transition"
                >
                  Cookies
                </a>
              </div> */}
          </div>
        </div>
      </footer>
    </>
  );
}
